import React, { FunctionComponent, useState } from 'react';
import '../../../styles/news-forge.styles.scss';
import { DATA_QA } from '../../../helpers/data-qa';
import { useDispatch, useSelector } from 'react-redux';
import { INewsForgeGeneratedArticle } from '../../../models/news-forge.models';
import NewsForgeHttpService from '../../../helpers/news-forge-http.service';
import { NewsForgeErrorState } from '../../../helpers/news-forge.helper';
import { showCustomToast } from '../../../../ArticleAiGeneration/components/subcomponents/schedules-listing-components/subcomponents/custom-toast-norification';
import { GenerateArticleRequestStatuses } from '../../../../ArticleAiGeneration/helpers/article-ai-generation.helper';
import { useReactQueryMutationWrapper } from '../../../../../../services/react-query/react-query.helper';
import { AppState } from '../../../../../../store/store';
import { updateNewsForgeContent } from '../../../../../../store/action-creators/news-forge-action-creator';
import i18next from 'i18next';
import { CreatedArticleModal } from '../modal/created-article-modal';

export type ButtonProps = {
	text: string;
	title?: string;
	maxWidth?: string;
	onClickAction?: (event: React.MouseEvent) => void;
	setErrorState: (errorState: NewsForgeErrorState) => void;
	disabled: boolean;
};

export const CreateArticleButton: FunctionComponent<ButtonProps> = ({ text, title, maxWidth, setErrorState, disabled }) => {
	const dispatch = useDispatch();
	const newsForgeContent = useSelector((state: AppState) => state.newsForge.newsForgeContent);
	const [showModal, setShowModal] = useState(false);
	const [createdArticleId, setCreatedArticleId] = useState<string | null>(null);

	const { mutate: createArticle } = useReactQueryMutationWrapper(
		async (payload: INewsForgeGeneratedArticle) => {
			const { data } = await NewsForgeHttpService.createdExtractedArticle(payload);
			return data;
		},
		{
			onSuccess: (data) => {
				if (data && data.data && data.data.id) {
					setCreatedArticleId(data.data.id);
					setShowModal(true);
					showCustomToast(i18next.t('success'), i18next.t('article_create_success'), GenerateArticleRequestStatuses.SUCCESS);
				}
			},
			onError: (error) => {
				showCustomToast(i18next.t('error'), error.message, GenerateArticleRequestStatuses.ERROR);
			},
		},
	);

	const handleClick = (e: React.MouseEvent) => {
		const translated_content = newsForgeContent && newsForgeContent.translated_content;
		const category = newsForgeContent && newsForgeContent.category;

		if (!category || !category.id) {
			const updatedErrorState: NewsForgeErrorState = {
				category: true,
				target_url: false,
				original_content_title_limit: false,
				translated_content_title_limit: false,
				translated_content_title: false,
			};
			setErrorState(updatedErrorState);
			dispatch(updateNewsForgeContent({ ...newsForgeContent }));
			showCustomToast('Error', i18next.t('news_forge_category_error'), GenerateArticleRequestStatuses.ERROR);
			return;
		}

		const strippedTitle =
			translated_content && translated_content.title ? translated_content.title.replace(/<p>/g, '').replace(/<\/p>/g, '').trim() : '';

		const articleData: INewsForgeGeneratedArticle = {
			title: strippedTitle,
			content: translated_content && translated_content.content ? translated_content.content : '',
			category_id: category.id,
		};

		!disabled && createArticle(articleData);
	};

	return (
		<>
			<div data-qa={DATA_QA.NEWS_FORGE_CREATE_ARTICLE_BUTTON} className='create-article-button-container'>
				<div
					className={`create-article-button ${disabled ? 'disabled' : ''}`}
					title={title}
					style={{ maxWidth: maxWidth || 'auto' }}
					onClick={handleClick}
				>
					<span className='button-label'>{text}</span>
				</div>
			</div>
			<CreatedArticleModal showModal={showModal} setShowModal={setShowModal} articleId={createdArticleId} />
		</>
	);
};

export default CreateArticleButton;
